import { api } from "../../../services/api";

export async function getMotoboy({ company }) {
  const { data } = await api.get(`/getMotoboy/${company}`);
  return data;
}
